/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для правого виджета корзины на странице корзины
   */
  app.CartBillView = app.View.extend({
    events: {
      'click #checkout': 'checkReOrders',
      'click .js-button-auth': app.helpers.RedirectHelper.goToAuth.bind(app.helpers.RedirectHelper, '?returnUrl=/checkout/'),
      'click #add_to_jp': 'addToJp',
      'click .js-show-delivery-weight-info': 'toggleDeliveryWeightInfoPopup',
      'click .js-show-cart-summary-popup': 'toggleCartSummaryInfoPopup',
      'click .js-close-delivery-weight-info': 'toggleDeliveryWeightInfoPopup',
      'click .js-toggle-order-progress-info': 'toggleOrderProgressInfoPopup',
      'click .js-open-cost-modifier-popup': 'toggleCostModifierPopup',
    },
    additionalOptions: ['jsView', 'mainWindow', 'bodyView'],

    /** @inheritDoc */
    run: function () {
      this.priceTemplate = app.helpers.TemplateHelper.getTemplate('#bill-price-template');
      this.cartSummaryBlocksTemplate = app.helpers.TemplateHelper.getTemplate('#cart-summary-block');
      this.orderProgressTemplate = app.helpers.TemplateHelper.getTemplate('#order-progress');
      this.totalSumLabelTemplate = app.helpers.TemplateHelper.getTemplate('#bill-total-sum-label-template');
      this.cartDiscountBlockTemplate = app.helpers.TemplateHelper.getTemplate('#cart-discount_block-template');
      this.cartMoreDeliveryTypeTemplate = app.helpers.TemplateHelper.getTemplate('#cart-more-delivery-type-comment');
      this.tooltipWeigthTemplate = app.helpers.TemplateHelper.getTemplate('#cart-bill-weight-template');
      this.weightInfoPopupTemplate = app.helpers.TemplateHelper.getTemplate('#cart-bill-popup-weight-template');
      this.cartSummaryPopupTemplate = app.helpers.TemplateHelper.getTemplate('#cart-summary-popup-template');
      this.remoteItemsBillBlockTemplate = app.helpers.TemplateHelper.getTemplate('#remote-items-bill-block-template');
      this.costModifiersInfoTemplate = app.helpers.TemplateHelper.getTemplate('#cart-bill-cost-modifier-template');
      this.costModifiersPopupTemplate = app.helpers.TemplateHelper.getTemplate('#cost-modifier-popup-template');
      this.listenTo(this.settlement, 'change:canOrderAsGuest', this.renderButtonTemplate);
      this.listenTo(Backbone, 'update-cart-info', this.toggleAddToJpButton);
      this.listenTo(Backbone, 'update-cart-info', this.updateOrderWeight);
      this.listenTo(Backbone, 'DeleteItemFromCart', this.toggleAddToJpButton);
      this.listenTo(this.cart, 'sync', this.getOrderConditions);
      this.listenTo(this.cart, 'sync', this.getOrderProgress);
      this.listenTo(this.cart, 'sync', this.toggleAddToJpButton);
      this.listenTo(this.cart, 'sync', this.updateSum);
      this.listenTo(this.cart, 'delivery-info-change', this.updateSum);
      this.listenTo(this.settlement, 'sync', this.toggleAddToJpButton);
      this.initOrderConditions();
      this.initOrderProgress();
      this.createMinSumPopupView();
      this.initReorderPopup();
      this.initRemotePopup();
      if (this.user && !app.isTerminal && !app.features.is_hide_delivery_info_in_cart_segments) {
        this.deliveryCollection = new app.CartItemDelivery();
      }
      this.initLoader();
      var viewOptions = {
        settlement: this.settlement,
        cart: this.cart,
        bodyView: this.bodyView,
        mainWindow: this.mainWindow,
        renderBillLoader: this.renderLoader.bind(this),
        removeBillLoader: this.removeLoader.bind(this),
      };
      if (!app.isMobile) {
        this.childViews.checkoutRestrictedItemsPopupView = new app.CheckoutRestrictedItemsPopupView(viewOptions);
        this.childViews.fastDeliveryView = new app.CartFastDeliveryView({
          cart: this.cart,
          settlement: this.settlement,
          el: this.$('.js-fast-delivery-block'),
        });
      } else {
        this.childViews.checkoutRestrictedItemsPopupView = new app.MobileRestrictedItemsPopupView(viewOptions);
        this.initCostModifiersPopup();
      }
      this.listenTo(Backbone, 'DeleteItemFromCart', this.updateRemoteItems);
      this.listenTo(this.settlement, 'change', this.updateRemoteItems);
      var isUpsaleEnabled = this.user && this.user.get('is_upsale_enabled');
      if (!app.isMobile && isUpsaleEnabled) {
        this.initUpsaleItemView();
      }
      this.showMoreDeliveryTypesComment();
      this.listenTo(this.cart, 'sync', this.showMoreDeliveryTypesComment);
      this.listenTo(this.cart, 'sync', this.checkOnlyGiftAdded);
      this.listenTo(this.orderProgress, 'sync', this.renderOrderProgress);
      this.initTransitMessageView();
      this.initRemainsView();
    },

    /**
     * Инициализация прелоадера.
     */
    initLoader: function() {
      this.childViews.loader =  new app.LoaderView({
        contentWrapper: this.$el.find('.js-b-cart-bill-wrapper'),
        withFade: true,
        mainWindow: this.mainWindow,
        sizeClass: 'medium',
        isWhite: true,
        invisibleLoader: true,
      });
      this.listenTo(this.cart, 'request', function () {
        if (this.cart.length) {
         this.renderLoader();
        }
      });
      this.listenTo(this.cart, 'sync', function () {
        if (!this.deliveryCollection) {
          this.removeLoader();
        }
      });
      this.listenTo(this.orderConditions, 'request', function () {
        if (this.cart.length) {
          this.orderConditions.isFetching = true;
          this.renderLoader();
        }
      });
      this.listenTo(this.orderConditions, 'sync', function () {
        if (this.cart.length) {
          this.orderConditions.isFetching = false;
          this.removeLoader();
        }
      });
      this.listenTo(this.deliveryCollection, 'sync', function () {
        this.removeLoader();
      });
      this.renderLoader();
    },

    /**
     * Показать лоадер.
     */
    renderLoader: function() {
      this.childViews.loader && this.childViews.loader.render();
    },

    /**
     * Удалить лоадер.
     */
    removeLoader: function() {
      this.childViews.loader && this.childViews.loader.remove();
    },

    /**
     * Инициализация модели доступности заказа.
     */
    initOrderConditions: function () {
      this.orderConditions = new app.OrderConditions(null, {
        settlement: this.settlement,
        remote_order: this.hasRemoteItems() ? 1 : 0,
      });
    },

    /**
     * Инициализация модели прогресс бара.
     */
    initOrderProgress: function () {
      this.orderProgress = new app.OrderProgress(null, {
        settlement: this.settlement,
        currency: app.currentCurrency,
      });
    },

    /**
     * Показать/скрыть попап о способе доставки курьером в зависимости от веса.
     * @param {Event} e Событие
     */
    toggleDeliveryWeightInfoPopup: function (e) {
      var groupName = $(e.currentTarget).data('group');
      if (groupName) {
        var group = this.cart.getGroupByName(groupName);
        if (group) {
          var notice = group.delivery_lifter_notice || {};
          this.$('.js-weight-info').html(this.weightInfoPopupTemplate({
            tooltipTitle: notice.title,
            tooltipText: notice.text,
          }));
        }
      }
      if (Array.isArray(this.cart.cartSummaryBlocks)) {
        this.$('.js-delivery-weight-info-popup-summary').toggleClass('not_display');
      } else {
        this.$('.js-delivery-weight-info-popup').toggleClass('not_display');
      }

      $('body').toggleClass('body-hidden');
    },

    /**
     * Показать/скрыть попап информации из summary-block.
     * @param {Event} e Событие
     */
    toggleCartSummaryInfoPopup: function (e) {
      var cartSummaryPopupId = e && e.currentTarget && e.currentTarget.dataset && e.currentTarget.dataset.cart_summary_popup_id;
      if ((cartSummaryPopupId || cartSummaryPopupId === 0)) {
        var description = this.cart.cartSummaryBlocks[cartSummaryPopupId] && this.cart.cartSummaryBlocks[cartSummaryPopupId].description;
        if (description) {
          this.$('.js-cart-summary-info').html(this.cartSummaryPopupTemplate({
            tooltipTitle: description.title,
            tooltipText: description.text,
            bottomImage: description.bottomImage,
            rightImage: description.rightImage,
          }));
          this.$('.js-delivery-weight-info-popup-summary').toggleClass('not_display');
          $('body').toggleClass('body-hidden');
        }
      }
    },

    /**
     * Показать/скрыть попап информации прогресс бара.
     */
    toggleOrderProgressInfoPopup: function () {
      this.$('.js-order-progress-popup').toggleClass('not_display');
      if (app.isMobile) {
        $('body').toggleClass('body-hidden');
      } else {
        this.$('.js-popup-container').toggleClass('not_display');
      }
    },

    /**
     * Обновление модели доступности заказа.
     */
    getOrderConditions: function () {
      this.orderConditions.fetch();
    },

    /**
     * Отрисовка лоадера прогресс бара.
     */
    renderOrderProgressLoader: function () {
      var containerWrapper = this.$el.find('.js-delivery-order-progress');
      if (!this.childViews.orderLoader && containerWrapper) {
        this.childViews.orderLoader =  new app.LoaderView({
          contentWrapper: containerWrapper,
          withFade: true,
          sizeClass: 'medium',
          loaderClass: 'preloader-ring progress-preloader',
          faderClass: 'progress-preloader-wrapper preloader-back',
        });
      }
      if (!this.$('.js-delivery-order-progress').hasClass('not_display')) {
        this.childViews.orderLoader && this.childViews.orderLoader.render();
      }
    },

    /**
     * Удаление лоадера прогресс бара.
     */
    removeOrderProgressLoader: function () {
      this.childViews.orderLoader && this.childViews.orderLoader.remove();
    },

    /**
     * Запрос прогресс бара доставки.
     */
    getOrderProgress: function () {
      this.renderOrderProgressLoader();
      this.orderProgress.fetch();
    },

    /**
     * Инициализация попапа заказа товаров с удаленного склада
     */
    initRemotePopup: function () {
      // Инициализируем отдельную коллекцию корзины с дополнительными параметрами
      var remoteCartItems = new app.Cart(null, {settlement: this.settlement});
      remoteCartItems.queryParams.group = 'remote';
      remoteCartItems.state.pageSize = 100;
      this.childViews.remotePopup = new app.CartRemotePopupView({
        el: '.js-checkout-remote-popup',
        collection: remoteCartItems,
        cart: this.cart,
        settlement: this.settlement,
      });
    },

    /**
     * Если корзина не готова, ждем события готовности и валидируем еще
     * @param {function} onValidationReady
     * @returns {boolean} Признак готовности корзины
     */
    checkCartReady: function (onValidationReady) {
      if (!this.cart.isCartItemsReady()) {
        this.listenToOnce(
          this.cart,
          'cart:ready-for-validation',
          onValidationReady
        );
        return false;
      } else if (this.orderConditions.isFetching) {
        this.listenToOnce(
          this.orderConditions,
          'sync',
          onValidationReady
        );
        return false;
      }
      return true;
    },

    /**
     * Запуск проверки возможности оформить заказ.
     * При успешном прохождении, переводит на оформление.
     * При неуспешном - показывает предупреждающие попапы.
     */
    validateOrder: function () {
      // если корзина готова
      if (this.checkCartReady(this.validateOrder)) {
        var restrictionsPopup = this.childViews.checkoutRestrictedItemsPopupView;
        var checkoutAllowed = this.orderConditions.get('checkout_allowed');
        var remoteAllowed = this.orderConditions.get('remote_allowed');

        // если есть ограничения
        if (restrictionsPopup.hasRestrictedItems) {
          this._proceedRestriction(restrictionsPopup);
          return;
        }

        // если заказ больше минимума или есть активные закупки в городе
        if (checkoutAllowed) {
          var hasOnlyRemoteItems = this.hasRemoteItems() && !this.cart.getGroups();
          if (hasOnlyRemoteItems) {
            // заказ товаров с удаленного склада
            this.goToRemoteCheckout();
          } else {
            // обычный заказ
            this.goToCheckout();
          }
        } else if (remoteAllowed) {
          this.showRemoteOrderPopup();
        } else {
          this.showMinSumMessage();
        }
      }
    },

    /**
     * Проверки на наличие в корзине товаров партнеров.
     * Возвращает true, если есть попап заказа с удаленного склада и товары с удаленного склада
     * @returns {boolean}
     */
    hasRemoteItems: function () {
      if (this.settlement.isRemoteStoreEnabled()) {
        if (this.childViews.remotePopup && this.cart.checkRemoteItems()) {
          return true;
        }
      }
      return false;
    },

    /**
     * Обработка ограничений
     * Показываем попап сообщающий об ограничениях
     * @param {Object} restrictionsPopup объект попапа
     * @private
     */
    _proceedRestriction: function (restrictionsPopup) {
      this.listenTo(restrictionsPopup, 'can_go_to_checkout', this.makeStandardOrder);
      this.showRestrictedItemsPopup();
    },

    /**
     * Отправляем на оформление заказа
     */
    goToCheckout: function () {
      app.helpers.RedirectHelper.goToCheckout();
      this.childViews.minSumOrderPopupView.close();
      this.renderLoader();
    },

    /** @inheritDoc */
    makeReorder: function (model, options) {
      var restrictionsPopup = this.childViews.checkoutRestrictedItemsPopupView;
      var makeReorder = this.saveReorder.bind(this, model, options);
      if (restrictionsPopup.hasRestrictedItems) {
        this.listenTo(restrictionsPopup, 'can_go_to_checkout', makeReorder);
        this.showRestrictedItemsPopup();
      } else {
        makeReorder();
      }
    },

    /**
     * Сохраняет дозаказ
     * @param {Object} order Заказ, к которому прикрепляется дозаказ
     * @param {Object} options Опции с которыми была сохранена модель
     */
    saveReorder: function (order, options) {
      if (order && order instanceof app.Order && order.get('id')) {
        var saveOptions = {
          success: this.redirectToOrder,
          subOrderId: order.get('id'),
        };
        if (options && options.saveOptions){
          _.extend(saveOptions, options.saveOptions);
        }
        (new app.Order()).reorder(order.get('id'), saveOptions);
      }
    },

    /**
     * Отправляем на оформление заказа с удаленного склада
     */
    goToRemoteCheckout: function () {
      app.helpers.RedirectHelper.goToCheckout({is_remote: true});
    },
    /**
     * Рендер кнопки
     */
    renderButtonTemplate: function (model) {
      var guestOrderTemplate = app.helpers.TemplateHelper.getTemplate('#cart-order-btn-template'),
        regularTemplate = app.helpers.TemplateHelper.getTemplate('#cart-checkout-btn-template');
      delete this.popup;
      if (!app.user.get('id') && model.get('canOrderAsGuest')) {
        if (guestOrderTemplate) {
          this.$('.cart-bill-btn-block').html(guestOrderTemplate);
        }
      } else {
        if (regularTemplate) {
          this.$('.cart-bill-btn-block').html(regularTemplate);
        }
      }
      this.afterRun();
      this.reOrderPopup.opener = this.$('.js-popup-window-opener');
    },

    /**
     * Добавить заявку с товарами из корзины в собственную совместную закупку
     * @param e
     * @returns {app.Order} модель заказа-заявки
     */
    addToJp: function (e) {
      if (!this.checkCartReady(this.addToJp.bind(this, e)) || this.cart.cartInfo.sum === 0) {
        return;
      }
      var orderId;
      if (e && e.currentTarget && e.currentTarget.dataset && e.currentTarget.dataset.orderId){
        orderId = e.currentTarget.dataset.orderId;
      } else {
        return;
      }
      this.renderLoader();

      var data = {
        is_accept_agreement: 'on',
        jp_purchase_id: orderId,
        type: 'jp-request',
        contact_phone: app.user.get('phone'),
        contact_email: app.user.get('email'),
        contact_name: app.user.get('jp_organizer_name'),
        deliveryTypeId: 5,
        paymentTypeId: 4,
        settlement_id: this.settlement.get('settlement_id')
      };

      var order = new app.Order(data);
      this.listenToOnce(order, 'sync', this.jpOrderSuccess);
      this.listenToOnce(order, 'error', this.showOrderSaveError);
      order.save(data);
      return order;
    },

    /**
     * Обработка успешной заявки СП, отправка данных в ОКО, редирект на управление закупкой.
     * @param {app.Order} model Модель заказа
     */
    jpOrderSuccess: function (model) {
      var orderData = {
        n: 'order',
        sum: parseFloat(model.get('total')),
        id: parseInt(model.id, 10),
        type_id: app.ORDER_TYPE_ID.jpRequest
      };
      app.helpers.OkoHelper.awaitPush(
        orderData,
        this.redirectToJpControl.bind(this)
      );
    },

    /**
     * Редирект в управление заявками на СП
     */
    redirectToJpControl: function () {
      app.helpers.RedirectHelper.locationAssign('/cabinet/joint-purchase/control/');
    },

    /**
     * Показать ошибку при сохранении заявки в совместную покупку
     * @param {app.Model} [model] Модель заказа.
     * @param {Object} xhr Объект запроса.
     */
    showOrderSaveError: function (model, xhr) {
      xhr = xhr || {};
      var errors = Array.isArray(xhr.responseJSON) ? xhr.responseJSON : [];
      app.helpers.ErrorHelper.globalValidationError(errors, 'При добавлении заказа в совместную покупку');
      app.preloader.remove();
    },

    /**
     * Показать попап с ограничениями по температуре
     */
    showRestrictedItemsPopup: function () {
      if (this.reOrderPopup && !this.reOrderPopup.popup.closed_) {
        this.reOrderPopup.popup.close();
      }
      this.childViews.checkoutRestrictedItemsPopupView.checkRestrictions();
    },

    /**
     * Обновить товары удаленного склада
     * и показать попап заказа с удаленного склада
     */
    showRemoteOrderPopup: function () {
      var remotePopup = this.childViews.remotePopup;
      if (remotePopup){
        remotePopup.fetchAndShow();
      }
    },

    /**
     * Оформление заказа.
     */
    makeStandardOrder: function () {
      this.validateOrder();
    },

    /**
     * Обновление суммы.
     * Обновление информации о товарах удаленного склада
     */
    updateSum: function () {
      if (this.cart && this.cart.length) {
        if (this.deliveryCollection instanceof app.CartItemDelivery) {
          this.requestDelivery();
        } else {
          this.updateSumWithDelivery();
        }
        if (Array.isArray(this.cart.cartSummaryBlocks)) {
          this.renderCartSummaryBlock(this.cart.cartSummaryBlocks);
        }
      }
      if (this.cart.cartInfo.sum > 0) {
        this.$('#checkout, .js-hiding-button').removeAttr('disabled');
      } else {
        this.$('#checkout, .js-hiding-button').attr('disabled', true);
      }
    },

    /**
     * Запрашивает необходимую страницу товаров доставки в зависимости от текущих данных о корзине.
     */
    requestDelivery: function () {
      this.renderLoader();
      var deliveryState = this.deliveryCollection.state,
        currentDeliveryPage = deliveryState.currentPage,
        hasDeliveryModels = Boolean(this.deliveryCollection.models.length),
        cartInfo = this.cart.cartInfo,
        realDeliveryPagesCount = Math.ceil(cartInfo.items_count / deliveryState.pageSize),
        hasNextPage = this.deliveryCollection.hasNextPage(),
        neededPage = realDeliveryPagesCount,
        realPagesCountBecameMore = realDeliveryPagesCount > currentDeliveryPage,
        neededPageIsIncorrect = isNaN(neededPage) || !isFinite(neededPage) || neededPage < 1;
      if (!hasDeliveryModels || hasNextPage || realPagesCountBecameMore || neededPageIsIncorrect) {
        neededPage = 1;
      }
      this.deliveryCollection.getPage(neededPage, {
        fetch: true,
        success: this.updateSumWithDelivery.bind(this),
      });
    },

    /**
     * Обновляет стоимости после получения ответа от API доставок.
     * @param {boolean} needReRenderList Необходимо ли, перерисовать список товаров в доставке.
     */
    updateSumWithDelivery: function () {
      this.updateExtraSum.apply(this, arguments);
      this.updateRemoteItems();
      if (!app.isMobile) {
        this.childViews.fastDeliveryView.updateFastDelivery();
      }
      if (this.deliveryCollection) {
        this.updateDeliverySum();
      }
    },

    /**
     * Обновляет сумму
     */
    updateExtraSum: function () {
      var deliveryExtraPrice = app.features.is_hide_delivery_info_in_cart_segments ? 0 : this.getDeliveryExtraPrice(),
        discountSum = this.cart.cartInfo.sum - this.cart.cartInfo.sum_with_discount,
        costModifiersSum = 0,
        sum = this.cart.cartInfo.sum;
      if (this.cart.costModifiers) {
        costModifiersSum = this.cart.costModifiers.reduce(function (sum, modifier) {
          return sum += modifier.cost;
        }, costModifiersSum);
      }
      var fullSum = app.helpers.NumberHelper.roundFloatPointNum(
        this.getTotalSum(sum, discountSum, deliveryExtraPrice, costModifiersSum)
      );
      // Шаблон для цены в блоке "итого"
      this.$('.price_xlarge').html(this.priceTemplate({price: app.helpers.NumberHelper.numberWithoutZeroFraction(fullSum)}));
      // Шаблон для цены товаров
      this.$('.price_small')
        .not('.jp-delivery')
        .not('.js-delivery-price')
        .not('.js-cost-modifier-price')
        .html(this.priceTemplate({price: app.helpers.NumberHelper.numberWithoutZeroFraction(sum)}));
      this.$('.price_discount').html(this.priceTemplate({price: app.helpers.NumberHelper.numberWithoutZeroFraction(discountSum)}));
      this.renderTitleTotal(discountSum);
      if (app.isMobile) {
        this.childViews.choiceCityItemView = new app.ChoiceCityItemView({
          el: this.$('.choice-city'),
          settlement: this.settlement,
          user: this.user,
        });
      }
    },

    /**
     * Шаблон для заголовка блока "Итого"
     * @param {number} discountSum Стоимость скидки.
     */
    renderTitleTotal: function (discountSum) {
      var threeByTwoSum = this.cart.threeByTwoDiscountSum || 0,
        $discountBlock = this.$('.discount_block'),
        $discountBlockPopup = this.$('.js-discount_block-popup'),
        $resultSumBlock = this.$('.js-result-sum');
      $resultSumBlock.html(this.totalSumLabelTemplate({
        'discountSum': discountSum,
      }));
      if (discountSum > 0) {
        $discountBlock.removeClass('not_display');
        $discountBlockPopup.html(this.cartDiscountBlockTemplate({
          'discountSum': discountSum,
          'threeByTwoSum': threeByTwoSum
        }));
      } else {
        $discountBlock.addClass('not_display');
      }
    },

    /**
     * Обновление информации о товарах удаленного склада
     */
    updateRemoteItems: function () {
      // groups != null, когда есть товары и с удаленного склада, и с локального
      var groups = this.cart.getGroups(),
        $allRow = this.$('.js-all-items-row'),
        $remoteBlock = this.$('.js-remote-items-block'),
        showGroups = Boolean(groups && this.settlement.isRemoteStoreEnabled());
      var fractionNumber = app.helpers.NumberHelper.numberWithoutZeroFraction.bind(app.helpers.NumberHelper);
      $allRow.toggleClass('not_display', showGroups);
      $remoteBlock.toggleClass('not_display', !showGroups);

      // Если есть разные группы товаров и страна - Россия
      if (showGroups) {
        var simaItems = groups.local,
          remoteItems = groups.remote;
        var deliveryLifterNotice = simaItems.delivery_lifter_notice || {};
        var remoteDeliveryLifterNotice = remoteItems.delivery_lifter_notice || {};
        $remoteBlock.html(this.remoteItemsBillBlockTemplate({
          currency: app.currentCurrency.sign,
          simaWeight: this._getFormattedWeight(simaItems.weight),
          remoteWeight: this._getFormattedWeight(remoteItems.weight),
          simaItemsSum: fractionNumber(simaItems.sum),
          remoteItemsSum: fractionNumber(remoteItems.sum),
          simaTooltipTitleText: deliveryLifterNotice.title,
          simaTooltipText: deliveryLifterNotice.text,
          remoteTooltipTitleText: remoteDeliveryLifterNotice.title,
          remoteTooltipText: remoteDeliveryLifterNotice.text,
        }));
      }
      this.updateDeliverySum();
      this.renderCostModifiersInfo();
    },

    /**
     * Обновляет стоимость доставки.
     */
    updateDeliverySum: function () {
      if (this.deliveryCollection && !app.features.is_hide_delivery_info_in_cart_segments) {
        var showGroups = Boolean(this.cart.getGroups() && this.settlement.isRemoteStoreEnabled()),
          $targetRow = this.$(showGroups ? '.js-remote-items-block' : '.js-all-items-row'),
          deliveryTerms = this.deliveryCollection._cart || {},
          template = app.helpers.TemplateHelper.getTemplate('#cart-bill-delivery-row-template');
        $targetRow.find('.js-delivery-row').remove();
        $targetRow.append(template({
          currency: app.currentCurrency.sign,
          deliveryPrice: app.helpers.NumberHelper.numberWithoutZeroFraction(deliveryTerms.delivery_total),
          canOpenPopup: this.deliveryCollection.hasExtraInfo(),
          deliveryTerms: deliveryTerms,
        }));
      }
    },

    /** @inheritDoc */
    getDeliveryExtraPrice: function () {
      return _.get(this, 'deliveryCollection._cart.delivery_total', 0);
    },

    /**
     * Обновление состояния кнопки "Добавить в СП" в зависимости
     * от итоговой суммы и товаров транзитов в корзине.
     */
    toggleAddToJpButton: function () {
      var $el = this.$('#add_to_jp');
      var cart = this.cart;
      var hasTransit = Boolean(
        cart
        && cart.transit_settlements
        && cart.transit_settlements.length
      );
      var hasItems = Boolean(cart && cart.cartInfo && cart.cartInfo.sum);
      if ($el.length) {
        $el.prop('disabled', !hasItems || hasTransit);
      }
    },

    /**
     * Обновление веса заказа.
     */
    updateOrderWeight: function () {
      var $containerWithTooltip = this.$('.js-weight');
      var $container = this.$('.js-weight-nowrap');
      var allGroup = this.cart.getGroupByName('all') || {};
      var weight = this._getFormattedWeight(allGroup.weight);
      var notice = allGroup.delivery_lifter_notice || {};
      if ($containerWithTooltip.length) {
        $containerWithTooltip.html(this.tooltipWeigthTemplate({
          weight: weight,
          tooltipTitle: notice.title,
          tooltipText: notice.text,
        }));
      } else {
        this.$('.js-cart-weight').html(weight);
        this.$('.js-show-delivery-weight-info').toggleClass('not_display', !notice.title && !notice.text);
      }
      $container.toggleClass('not_display', weight === 0);
    },

    /**
     * Инициализирует блок допродажи в корзине.
     */
    initUpsaleItemView: function () {
      this.upsaleItem = new app.UpsaleItem();
      var upsaleView = this.childViews.cartUpsaleView = new app.CartUpsaleView({
        model: this.upsaleItem,
        cart: this.cart,
        user: this.user,
        settlement: this.settlement,
      });
      upsaleView.fetchWithCurrentCurrency();
      upsaleView.listenTo(
        Backbone,
        'change-currency',
        upsaleView.fetchWithCurrentCurrency
      );
    },

    /**
     * Возвращает форматированный вес.
     * @param {number|string} weight Вес корзины.
     * @return {string|number} Форматированный вес.
     * @private
     */
    _getFormattedWeight: function (weight) {
      var result = 0;
      if (weight < 1 && weight > 0) {
        result = weight > 0.1 ? weight.toFixed(1) : 0.1;
      } else if (weight >= 1) {
        // Если вес > 1 кг то нужна только целая часть.
        result = parseInt(weight, 10);
      }
      return result;
    },

    /**
     * Показывать блок с информацией о более выгодных типах доставки, если сумма заказа будет больше минимума.
     */
    showMoreDeliveryTypesComment: function () {
      var minOrderSum = this.cart.minOrderSum;
      var moreDeliveryComment = this.$('.js-more-delivery-type-comment');
      var cartSum = this.cart.cartInfo.sum;
      var isShowMinSumInfo = cartSum < minOrderSum
        && this.settlement && this.settlement.get('has_active_jp_purchase');
      if (isShowMinSumInfo) {
        moreDeliveryComment
          .html(this.cartMoreDeliveryTypeTemplate({
            minOrderSum: app.helpers.NumberHelper.fractionNumber(minOrderSum)[0],
            currency: app.currentCurrency.sign,
          }));
      }
      moreDeliveryComment.toggleClass('not_display', !isShowMinSumInfo);
    },

    /**
     * Инициализирует сообщения о невозможности заказать товар транзит.
     */
    initTransitMessageView: function () {
      this.childViews.CartTransitMessageView = new app.CartTransitMessageView({
          settlement: this.settlement,
          cart: this.cart,
        }
      );
    },

    /**
     * Инициализирует сообщениe об изменение баланса товаров в корзине.
     */
    initRemainsView: function () {
      var items = new app.ItemPageableCollection();
      items.url = app.entryScriptName + '/api/v3/cart-item/?expand=item&not_enough=1';
      items.loadFilters = false;
      items.requestFilters = false;

      this.childViews.cartRemainsView = new app.CartRemainsView({
        cart: this.cart,
        collection: items,
        bodyView: this.bodyView,
        mainWindow: this.mainWindow,
      });
    },

    /**
     * Инициализация попапа с информацией о наценке
     */
    initCostModifiersPopup: function () {
      if (typeof app.MobilePopupFillView !== 'undefined') {
        this.childViews.costModifierPopupView = new app.MobilePopupFillView({
          el: $('.js-cost-modifier-popup'),
          bodyView: this.bodyView,
        });
      }
    },

    /**
     * Рендерит информацию о дополнительных наценках.
     */
    renderCostModifiersInfo: function () {
      this.$('.js-cost-modifier-row').remove();
      var isHideDelivery = app.isTerminal || app.features.is_hide_delivery_info_in_cart_segments;
      if (this.cart.costModifiers) {
        var $targetRow = isHideDelivery ? this.$('.discount_block') : this.$('.js-delivery-row'),
          insertMethod = isHideDelivery ? 'after' : 'before';
        this.cart.costModifiers.forEach(function (costModifier) {
          var modifierCost = app.helpers.NumberHelper.numberWithoutZeroFraction(costModifier.cost);
          var costModifierDescription = costModifier.texts ? costModifier.texts.description :  '';
          if (this.childViews.costModifierPopupView) {
            this.childViews.costModifierPopupView.$el
              .find('.popup-container')
              .html(this.costModifiersPopupTemplate({
                name: costModifier.name,
                description: costModifierDescription,
              }));
          }
          $targetRow[insertMethod](this.costModifiersInfoTemplate({
            name: costModifier.name,
            cost: modifierCost,
            currency: app.currentCurrency.sign,
            description: costModifierDescription,
          }));
        }.bind(this));
      }
    },

    /**
     * Переключает попап с информаций о наценках.
     */
    toggleCostModifierPopup: function () {
      this.childViews.costModifierPopupView.popup.open();
      return false;
    },

    /**
     * Создание попапа с сообщением о минимальной сумме заказа
     */
    createMinSumPopupView: function () {
      this.childViews.minSumOrderPopupView = new app.minSumOrderPopupView({
        orderConditions: this.orderConditions,
        cart: this.cart,
        settlement: this.settlement,
      });
    },

    /**
     * Открываем попап с минимальной суммой
     */
    showMinSumMessage: function () {
      this.childViews.minSumOrderPopupView.open();
    },

    /**
     * Инициализация попапа дозаказа
     */
    initReorderPopup: function () {
      if (!this.orders) {
        this.orders = new app.Orders();
      }
      this.reOrderPopup = new app.CartReorderingPopupView({
        opener: this.$('#checkout'),
        el: '[data-popup-id="re-ordering"]',
        collection: this.orders,
        settlement: this.settlement,
        cart: this.cart,
        bodyView: this.bodyView,
      });

      this.listenTo(this.reOrderPopup, 'reordering-popup:make-standard-order', this.validateOrder);
      this.listenTo(this.reOrderPopup, 'reordering-popup:make-reorder', this.makeReorder);
      this.listenTo(this.orders, 'sync', this.render);
    },

    /**
     * Загрузка заказов для диалога выбора к какому заказу прикрепить дозаказ
     */
    checkReOrders: function () {
      // Если пользователь не авторизован, создаем обычный заказ
      if (!app.user.get('id')) {
        this.validateOrder();
        return;
      }
      // Если пользователь авторизован, проверяем предыдущие заказы
      this.checkPreviousOrders();
    },

    /**
     * Проверяем, есть ли у пользователя активные заказы.
     * Если заказов нет, делаем обычный заказ,
     * если есть, показываем попап.
     */
    checkPreviousOrders: function () {
      this.renderLoader();
      this.listenToOnce(this.reOrderPopup, 'reordering-popup:updated', function (hasOrders) {
        this.removeLoader();
        if (!hasOrders) {
          this.validateOrder();
        }
      });
      this.reOrderPopup.checkReorders();
    },

    /**
     * Отправляет событие дозаказа в ОКО и перенаправляет на страницу заказа
     * @param {Object} model Модель заказа
     * @param {Object} response Ответ с сервера
     * @param {Object} options Опции с которыми была сохранена модель
     */
    redirectToOrder: function (model, response, options) {
      if (model.get('id')) {
        app.helpers.OkoHelper.awaitPush({
            n: 'order',
            id: parseInt(model.id, 10),
            type_id: app.ORDER_TYPE_ID.reOrder,
            sub_order_id: options.subOrderId,
            sum: parseFloat(model.get('total')),
          },
          function () {
            app.helpers.RedirectHelper.locationAssign('/order/done/' + model.get('id') + '/');
          });
      }
    },

    /**
     * Рендерит правый блок в корзине
     * @param {Array} cartSummaryBlock Модель заказа
     */
    renderCartSummaryBlock: function (cartSummaryBlock) {
      if (cartSummaryBlock.length > 0) {
        var $extraRows = this.$('.js-cart-extra-rows');
        $extraRows.html(this.cartSummaryBlocksTemplate({
          cartSummaryBlocks: cartSummaryBlock,
        }));
      }
    },

    /**
     * Рендерит прогресс бар.
     */
    renderOrderProgress: function () {
      var freeDelivery = this.orderProgress.get('free_delivery');
      var $orderProgress = this.$('.js-delivery-order-progress');
      if (freeDelivery && freeDelivery.is_visible) {
        $orderProgress.html(this.orderProgressTemplate({
          freeDelivery: freeDelivery,
          grapheme: app.currentCurrency.grapheme,
        }));
        $orderProgress.removeClass('not_display');
        this.removeOrderProgressLoader();
        var circleElement = document.querySelector('.progress-container');
        var progressElement = document.querySelector('.progress-circle');
        var radius = circleElement && circleElement.r && circleElement.r.baseVal && circleElement.r.baseVal.value;
        var circumference = 2 * Math.PI * radius;
        var elementStyles = progressElement && progressElement.style;

        if (elementStyles) {
          elementStyles.strokeDasharray = circumference + ' ' + circumference;
          elementStyles.strokeDashoffset = circumference;
          elementStyles.stroke = freeDelivery.progress === 100 ? '#09AB8B' : '#1f84db';
          if (freeDelivery.progress) {
            elementStyles.strokeDashoffset = circumference - freeDelivery.progress / 100 * circumference;
          }
        }

        this.sendOrderProgressOkoPush(freeDelivery);

      } else {
        this.removeOrderProgressLoader();
        $orderProgress.addClass('not_display');
      }
    },

    sendOrderProgressOkoPush: function (freeDelivery) {
      if (freeDelivery.progress === 100) {
        app.helpers.OkoHelper.push({
          'n': 'custom',
          'category': 'free_ship_bar',
          'custom_str': ['congrats_point', app.currentCurrency.name],
        });
      } else if (freeDelivery.shortfall) {
        app.helpers.OkoHelper.push({
          'n': 'custom',
          'category': 'free_ship_bar',
          'custom_str': ['free_point', app.currentCurrency.name],
          'custom_float': freeDelivery.shortfall,
        });
      } else if (freeDelivery.is_failed) {
        app.helpers.OkoHelper.push({
          'n': 'custom',
          'category': 'free_ship_bar',
          'custom_str': ['condition_not_perform', app.currentCurrency.name],
        });
      }
    },

    /**
     * Финальная сумма заказа
     * @param {Number} productSum - сумма цен товаров
     * @param {Number} discountSum - сумма скидок
     * @param {Number} deliverySum - сумма доставок
     * @param {Number} costModifiersSum - сумма наценок
     * @returns {Number} сумма заказа
     */
    getTotalSum: function (productSum, discountSum, deliverySum, costModifiersSum) {
      return productSum - discountSum + deliverySum + costModifiersSum;
    },

    /**
     * Проверяет добавлены ли только подарки за действие.
     * Скрывает лишнюю информацию, если нет добавленных товаров.
     */
    checkOnlyGiftAdded: function () {
      var isNotOnlyGifts = !(this.cart && this.cart.length <= 0 && !_.isEmpty(this.cart.giftsForActions));
      this.$('.js-cart-info-with-items-added').toggle(isNotOnlyGifts);
      this.$('.js-save-cart-list-link').toggle(isNotOnlyGifts);
      this.$('.js-aside-inner-with-only-gift-added').toggleClass('not_display', isNotOnlyGifts);
    }
  });
})(jQuery);

}.call(window));